export const SUBPERMIT_TYPES = {
  FIRE: 'firePermits',
  SEARCH: 'searchPermits',
  CLEANING: 'cleaningPermits',
  CAPACITY: 'capacityPermits'
}

export const SUBPERMIT_TAB_KEYS = {
  [SUBPERMIT_TYPES.FIRE]: 'fire',
  [SUBPERMIT_TYPES.SEARCH]: 'search',
  [SUBPERMIT_TYPES.CAPACITY]: 'capacity',
  [SUBPERMIT_TYPES.CLEANING]: 'cleaning'
}
